import { View } from 'react-native';
import TextLato from '../../../../../text/text-lato/TextLato';
import { styleDesktop, styleMobile } from '../StepCard.style';
import Button from '../../../../../buttons/button/Button';
import { Image } from 'expo-image';
import { FocusGroups } from '../../../../../focus-provider/FocusProvider.constants';
import { observer } from 'mobx-react-lite';
import { TestIDs } from 'src/constants/testIDs.constants';
import { useStore } from 'src/contexts/StoreContext';
import { modalTestID } from 'src/helpers/testIDs.helper';
import { brand } from 'src/theme/colors';
import { CardProps } from '../../ModalConfigurationSteps.types';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';
import { BoxStyleInfo } from '@photosi/expo-photosi-sdk/build/PrintUtils';
import { getFormattedPrice } from '../../../../../../helpers/price.helper';

export const BoxStyleCard = observer(({ item: boxStyle, index, isSelected, onPress, onFocus }: CardProps<BoxStyleInfo>) => {
  const { i18n } = useStore();
  const { isDesktop } = useResponsiveScreen();
  const style = isDesktop ? styleDesktop : styleMobile;

  return (
    <Button
      onFocus={onFocus}
      onPress={async () => onPress(boxStyle)}
      testID={modalTestID(TestIDs.CONFIGURATION_STEPS, index.toString())}
      focusId={modalTestID(TestIDs.CONFIGURATION_STEPS, index.toString())}
      focusGroup={FocusGroups.MODAL}
      focusOrder={index}
    >
      {({ focused }) => {
        return (
          <View style={[style.border, isSelected ? style.borderSelected : focused ? style.borderFocus : undefined]}>
            <View style={[style.card, isDesktop && { height: 355 }]}>
              <Image style={style.image} source={boxStyle.previewUrl ?? ''} />
              <View style={style.textContainer}>
                <TextLato style={style.textTitle}>
                  {i18n.t(`modal-configuration-steps:box-style:${boxStyle.code.toLocaleLowerCase()}`)}
                </TextLato>
                <TextLato style={style.textPrice}>
                  {/*{i18n.t(`modal-configuration-steps:box-style-price`, {price: boxStyle.formattedPrice})}*/}
                  {i18n.t(`modal-configuration-steps:box-style-price`, {
                    price: getFormattedPrice({ price: boxStyle.price, withCurrency: true }),
                  })}
                </TextLato>
              </View>
              {isDesktop && (
                <View style={[style.radioButton, isSelected && { borderColor: brand.main.water }]}>
                  {isSelected && <View style={style.radioButtonSelected} />}
                </View>
              )}
            </View>
          </View>
        );
      }}
    </Button>
  );
});
